// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__tsJB3","resendInfoText":"OnGoingPaymentBox_resendInfoText__1PlVj"};